module.exports = __webpack_public_path__ + "img/hondahrv.f18f80a9.png";